import React from "react";
import { Alert } from "@material-ui/lab";
import { NavLink } from "react-router-dom";
import DescriptionFormItem from "../../elements/userAdminFields/DescriptionFormItem";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledBreakWord } from "../../styles/styledBreakWord";
import NicknameFormItem from "../../elements/clients/NicknameFormItem";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";

const ClientsList = ({ clients, notification, setNotification }) => {
  const { t } = useTranslation("clientsPage");

  if (!clients) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (clients.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };


  return (
    <StyledScrollTable>
      <StyledTable
        width="992"
        size="14"
        className="admin-client-table"
      >
        <StyledTableHead
          scroll="auto"
          col="6"
          className="admin-client-table__head"
        >
          <div>
            {t("table.nickname")}
          </div>
          <div>
            {t("table.firstname")}
          </div>
          <div>
            {t("table.lastname")}
          </div>
          <div>
            E-mail
          </div>
          <div>
            {t("table.createDate")}
          </div>
          <div>
            {t("table.description")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {clients && clients.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="6"
              className="admin-client-table__row"
              onClick={(e) => {showDetails(e);}}
              cursor="pointer"
              as={NavLink}
              to={`/clients/${value.id}`}
            >
              <StyledCol>
                <NicknameFormItem
                  client={value}
                  t={t}
                  notification={notification}
                  setNotification={setNotification}
                />
              </StyledCol>
              <StyledCol>
                {value.firstname ?? t("table.empty")}
              </StyledCol>
              <StyledCol>
                {value.lastname ?? t("table.empty")}
              </StyledCol>
              <StyledCol inline>
                <StyledBreakWord as="p">
                  {value.email}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol>
                {TimestampToDateMoment(value.createDate)}
              </StyledCol>
              <StyledCol>
                <DescriptionFormItem
                  client={value}
                  t={t}
                  notification={notification}
                  setNotification={setNotification}
                />
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default ClientsList;